import { render } from "./NormalBikeServices.vue?vue&type=template&id=814c313a&scoped=true"
import script from "./NormalBikeServices.vue?vue&type=script&lang=js"
export * from "./NormalBikeServices.vue?vue&type=script&lang=js"

import "./NormalBikeServices.vue?vue&type=style&index=0&id=814c313a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814c313a"]])

export default __exports__